export default __webpack_public_path__ + "static/media/tooltip-alert.889042ec.svg";